import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-2 md:py-4 flex flex-col h-full" }
const _hoisted_2 = {
  class: "messages-container overflow-y-auto h-80 mb-4 flex-grow flex flex-col gap-2",
  ref: "scrollable"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "spacer mb-1" }, null, -1)
const _hoisted_4 = {
  key: 0,
  src: "/media/michael.jpg",
  alt: "avatar",
  class: "w-6 h-6 rounded-full mr-2"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "text-xs text-right text-gray-500 text" }
const _hoisted_7 = {
  key: 0,
  class: "message flex pr-24 justify-start"
}
const _hoisted_8 = { class: "block p-3 mb-2 rounded-lg border" }
const _hoisted_9 = { class: "flex justify-between mb-2 text-sm" }
const _hoisted_10 = { class: "font-medium" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "block pl-3 opacity-50" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Typing...", -1)
const _hoisted_13 = {
  key: 1,
  class: "input-container flex items-center justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DotsHorizontalIcon = _resolveComponent("DotsHorizontalIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedMessages, (message, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["message flex gap-2 items-end", {
          'pr-4 justify-start b': message.sender === 'system',
          'pl-12 justify-end': message.sender === 'user'
        }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col gap-2 p-2 px-3 rounded-lg border", {
            'bg-gray-50': message.sender === 'system'
          }]),
            style: _normalizeStyle({
            'min-width': message.sender === 'system' ? '200px' : '100px',
          })
          }, [
            (!_ctx.isPreviousMessageFromSameSender(index))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["font-medium flex items-center text-sm", { 'text-sky': message.sender == 'user' }])
                }, [
                  (message.sender == 'system')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(message.sender == 'system' ? (_ctx.botName || 'Steven')  : 'You'), 1)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "text-sm",
              innerHTML: message.text
            }, null, 8, _hoisted_5)
          ], 6),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatTime(message.timestamp)), 1)
        ], 2))
      }), 128)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.botName || 'Steven'), 1),
                _hoisted_11
              ]),
              _hoisted_12
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", {
      class: _normalizeClass(["divider h-px bg-gray-200", { 'bg-sky shadow-sm': _ctx.isFocused }])
    }, null, 2),
    (!_ctx.isDone)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "input-container flex items-start justify-between",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newMessage) = $event)),
            placeholder: "Type a message",
            class: "flex-grow py-2 pl-1 pr-3 rounded-l-lg border border-gray-300 outline-none border-none h-16",
            id: "chat-message",
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFocused = true)),
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isFocused = false)),
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.newMessage]
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: _normalizeClass(["bg-sky text-white font-medium px-4 py-1 mt-2 ml-2 rounded-sm", { 'opacity-50 pointer-events-none': _ctx.loading }])
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Send")
                ], 64))
              : (_openBlock(), _createBlock(_component_DotsHorizontalIcon, {
                  key: 1,
                  class: "w-5 h-5 mx-auto"
                }))
          ], 2)
        ], 32))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "p-2 px-8 rounded-lg text-dark border",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.startNewConversation && _ctx.startNewConversation(...args)))
          }, " Start a new conversation "),
          _createElementVNode("button", {
            class: "ml-2 p-2 px-8 rounded-lg bg-sky text-white",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.endChat && _ctx.endChat(...args)))
          }, " Close ")
        ]))
  ]))
}